
module.exports = {
	status: 'ready',
	title: '',
	notes: `
		https://www.w3.org/TR/wai-aria-practices/#alert
	`,
	context: {
		title: 'Kakor på FMV',
		text: 'På fmv.se använder vi kakor (cookies) för att webbplatsen ska fungera så bra som möjligt för dig. Vi använder också kakor för webbanalys för att göra webbplatsen bättre.',
		linkText: 'Läs mer om kakor och hur de används på fmv.se',
		buttonAcceptNecessary: 'Jag godkänner nödvändiga kakor',
		buttonAcceptFunctional: 'Jag godkänner funktionella kakor',
		buttonAcceptStatistics: 'Jag godkänner kakor för analytics',
		buttonSaveAndClose: 'Spara mina val och stäng'
	}
};
